import { PublicClientApplication } from '@azure/msal-browser'
import { AUTH_MODE, msalConfig } from './config'

// Single MSAL instance, created only in Entra mode. main.tsx initializes it
// (and processes any redirect response) before the app renders.
export const pca: PublicClientApplication | null =
    AUTH_MODE === 'entra' ? new PublicClientApplication(msalConfig) : null
